/**
 * @generated SignedSource<<22d9e30c2954de0d942e204f62a42551>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "displayAcquisitionPopupContainerQuery",
    "selections": [{
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseAcquisitionPopupQuery"
    }],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "displayAcquisitionPopupContainerQuery",
    "selections": [{
      "alias": "widgetConfig",
      "args": [{
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_widget"
        }
      }],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_widget\"})"
    }]
  },
  "params": {
    "cacheID": "313464f632aa4a7ebcf48c588c7b77c3",
    "id": null,
    "metadata": {},
    "name": "displayAcquisitionPopupContainerQuery",
    "operationKind": "query",
    "text": "query displayAcquisitionPopupContainerQuery {\n  ...hooksUseAcquisitionPopupQuery\n}\n\nfragment hooksUseAcquisitionPopupQuery on Query {\n  widgetConfig: appConfig(filter: {entityId: \"scmp_pwa_widget\"}) {\n    json\n    id\n  }\n}\n"
  }
};
node.hash = "3ff4df315a1765e4d99b01b77df32294";
export default node;